import { toUserMultiValueWithArchive } from '../User'

import { DocFlowSendingFieldName } from './DocFlowSending'

export function toRecipientArchivedMultiValue(value) {
  return value ? toUserMultiValueWithArchive(value) : null
}

export function hasDocFlowAdditionalEmails(item) {
  return item[DocFlowSendingFieldName.AdditionalEmail]?.length > 0
}

export function hasDocFlowNoRecipientInDeleteItems(tableItems, deleteItems) {
  return tableItems?.items.some(
    item => deleteItems.includes(item.id) && !item.recipient
  )
}
